(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.overview.big-figures.view
    :refer [overview-figures-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
    :refer [basic-information-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.view
    :refer [return-development-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.overview.recent-development-figures.view :as recent-dev]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]))

(defn tearsheet-section
  [tearsheet props]
  [section
   "Tear sheet"
   (str "tearsheet-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 12}
      [return-development-card tearsheet props]]]
    [basic-information-card tearsheet props]]])

(defn overview-section
  [{:keys [overview-figures
           highlights
           recent-development-text
           portfolio-at-market-value
           gav-breakdown]}
   props]
  [section
   "Overview"
   (str "overview-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [overview-figures-card overview-figures props]
    [recent-dev/recent-development-with-highlights-card recent-development-text highlights
     (assoc props :title "Fund Figures (INREV)")]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "Portfolio at fair value, MSEK" portfolio-at-market-value props]]
     [grid/column {:span 6}
      [chart-card/view "GAV breakdown, MSEK (INREV)" gav-breakdown props]]]]])

(defn inrev-nav-section
  [inrev-nav props]
  [section
   "INREV NAV"
   (str "inrev-nav-"
        (some->> props
                 :report
                 :db/id))
   [tabular-card/dynamic-table nil inrev-nav props]])

(defn debt-financing-section
  [{:keys [debt-financing-text
           portfolio-debt-financing]}
   props]
  [section
   "Debt financing"
   (str "debt-financing-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [:div
     [tabular-card/dynamic-table "Debt Financing, SEK" portfolio-debt-financing props]]
    [grid/row {}
     [grid/column {:large 12}
      [free-text-card/view "Description" debt-financing-text props]]]]])

(defn details-and-figures-section
  [{:keys [current-portfolio
           exited-portfolio
           investment-summary
           nav-breakdown-ifrs
           nav-breakdown-inrev]}
   props]
  [section
   "Details and figures"
   (str "details-and-figures-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Current portfolio, SEK" current-portfolio props]
    [tabular-card/dynamic-table "Exited portfolio, SEK" exited-portfolio props]
    [tabular-card/dynamic-table "Investment summary, SEK" investment-summary props]
    [tabular-card/dynamic-table "NAV breakdown (IFRS), SEK" nav-breakdown-ifrs props]
    [tabular-card/dynamic-table "NAV breakdown (INREV), SEK" nav-breakdown-inrev props]]])

(defn financial-statements-section
  [{:keys [group-income-statement
           statement-of-financial-position
           cash-flow-statement]}
   props]
  [section
   "Financial statements"
   (str "financial-statements-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Consolidated statement of comprehensive income (INREV), SEK"
     group-income-statement props]
    [tabular-card/dynamic-table "Consolidated statement of financial position (INREV), SEK"
     statement-of-financial-position props]
    [tabular-card/dynamic-table
     "Consolidated statement of cash flows (INREV), SEK"
     cash-flow-statement props]]])

(defn view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [tearsheet
                overview
                debt-financing
                inrev-nav
                details-and-figures
                financial-statements]}
        fund-ui-data]
    [:div
     ^{:key :tearsheet}
     [:div
      [tearsheet-section tearsheet props]]
     ^{:key :overview}
     [:div
      [overview-section overview props]]
     ^{:key :inrev-nav}
     [:div
      [inrev-nav-section inrev-nav props]]
     ^{:key :debt-financing}
     [:div
      [debt-financing-section debt-financing props]]
     ^{:key :details-and-figures}
     [:div
      [details-and-figures-section details-and-figures props]]
     ^{:key :group-income-statement}
     [:div
      [financial-statements-section financial-statements props]]]))
